import { render, staticRenderFns } from "./visaBonus.vue?vue&type=template&id=1686cc28&scoped=true&"
import script from "./visaBonus.vue?vue&type=script&lang=js&"
export * from "./visaBonus.vue?vue&type=script&lang=js&"
import style0 from "./visaBonus.vue?vue&type=style&index=0&id=1686cc28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1686cc28",
  null
  
)

export default component.exports